import React from "react";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./src/components/theme/global";
import { darkTheme } from "./src/components/theme/theme";

export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={darkTheme}>
    <GlobalStyles />
    {element}
  </ThemeProvider>
);
